import axios from './axiosInstance';
import { APIWidgetKey } from '../../types';

interface GetDefaultParams {
  sport: string;
  areaId: string;
}

const getDefault = ({ sport, areaId }: GetDefaultParams): Promise<APIWidgetKey> => {
  let url = `/${sport}/areas/${areaId}/widgetkeys/default`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const formFunctions = {
  getDefault,
};

export default formFunctions;
